import { notificationsRemoteEvent } from "domains/nav/constants/eventTypes";

export enum NotificationsHostCommand {
  NOTIFICATIONS_CLOSE = "NOTIFICATIONS_CLOSE",
  NOTIFICATIONS_OPEN = "NOTIFICATIONS_OPEN",
}

export enum NotificationsRemoteEvent {
  NOTIFICATIONS_CLOSED = "NOTIFICATIONS_CLOSED",
  NOTIFICATIONS_COUNT_UPDATE = "NOTIFICATIONS_COUNT_UPDATE",
  NOTIFICATIONS_OPENED = "NOTIFICATIONS_OPENED",
}

type NotificationsRemoteEventPayloads = { [NotificationsRemoteEvent.NOTIFICATIONS_COUNT_UPDATE]: { value: number } };

export const executeNotificationsRemoteEvent = <T extends NotificationsRemoteEvent>(
  event: T,
  payload: T extends keyof NotificationsRemoteEventPayloads ? NotificationsRemoteEventPayloads[T] : undefined,
) =>
  void window.dispatchEvent(new CustomEvent(notificationsRemoteEvent, { detail: { _type: event, _payload: payload } }));
